import { toRem, toRems } from 'helpers/theme'

/* eslint-disable quote-props */
const style = ({ theme }) => ({
    '& .SpecificationTitle': {
        display: 'none',
        fontSize: toRem(18),
        fontWeight: theme.typography.fontWeight.medium,

        [theme.breakpoints.up('md')]: {
            display: 'block'
        },

        [theme.breakpoints.up('lg')]: {
            fontSize: toRem(24)
        }
    },
    '& .SpecificationList': {
        listStyle: 'none',
        display: 'flex',
        flexWrap: 'wrap',
        margin: '48px 0',
        '& li': {
            width: '50%',
            paddingRight: toRem(40),
            marginBottom: toRem(25),
            fontSize: toRem(17),

            [theme.breakpoints.up('lg')]: {
                width: '33%'
            },

            [theme.breakpoints.up('xl')]: {
                fontSize: toRem(20)
            },

            '& span': {
                display: 'block',
                marginBottom: toRem(5),
                color: theme.colors.goldDark,
                fontSize: toRem(11),
                textTransform: 'uppercase',

                [theme.breakpoints.up('lg')]: {
                    fontSize: toRem(14)
                }
            }
        }
    }
})

export default style
